import { Button, Checkbox } from '@cian/ui-kit';
import * as React from 'react';
import { InputField } from '../InputField';
import { EAlignment, FormFieldHelper } from '../FormFieldHelper';
import { PasswordField } from '../PasswordField';
import { PhoneField } from '../PhoneField';
import { Link } from '../Link';
import { FormFieldGroupLayout } from '../FieldGroupLayout';
import { EActiveFlow } from '../../types/flow';
import { EKeyCode } from '../../types/keyCodes';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function UsernameAuthForm(props) {
  var handleSubmit = props.handleSubmit;
  var handlePreventSubmit = React.useCallback(function (e) {
    e.preventDefault();
  }, []);
  var handleSubmitOnEnter = React.useCallback(function (e) {
    if (e.keyCode === EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  return /*#__PURE__*/_jsx("form", {
    onSubmit: handlePreventSubmit,
    children: /*#__PURE__*/_jsx(FormFieldGroupLayout, {
      content: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(InputField, {
          "data-name": "EmailIdInput",
          name: "username",
          id: "username",
          autoComplete: "off",
          autoFocus: !props.autoFocusDisabled,
          disabled: props.isSubmitting,
          value: props.login,
          required: props.activeFlow === EActiveFlow.Registration,
          ref: props.loginRef,
          invalid: props.isLoginInvalid,
          errorMessage: props.loginError,
          onKeyDown: handleSubmitOnEnter,
          onChange: props.onLoginChange,
          type: "text",
          placeholder: "Email \u0438\u043B\u0438 id"
        }), /*#__PURE__*/_jsx(PasswordField, {
          name: "password",
          id: "password",
          hidden: props.activeFlow === null,
          tabIndex: props.activeFlow === null ? -1 : 0,
          placeholder: "\u041F\u0430\u0440\u043E\u043B\u044C",
          autoComplete: props.activeFlow === EActiveFlow.Registration ? 'new-password' : 'current-password',
          value: props.password,
          required: props.activeFlow === EActiveFlow.Registration,
          ref: props.passwordRef,
          invalid: props.isPasswordInvalid,
          disabled: props.isSubmitting,
          onChange: props.onPasswordChange,
          onKeyDown: handleSubmitOnEnter,
          errorMessage: props.passwordError,
          passwordShown: props.passwordShown,
          toggleVisibility: props.togglePasswordVisibility
        }), props.activeFlow === EActiveFlow.Authentication && /*#__PURE__*/_jsx(FormFieldHelper, {
          alignment: EAlignment.Right,
          marginBottom: true,
          children: /*#__PURE__*/_jsx(Link, {
            href: "#",
            onClick: props.onResetLinkClick,
            dataMark: "RemindPasswordLink",
            children: "\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?"
          })
        }), props.activeFlow === EActiveFlow.Registration && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(PhoneField, {
            id: "tel",
            name: "tel",
            autoComplete: "tel",
            placeholder: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
            value: props.phone,
            inputRef: props.phoneRef,
            invalid: props.isPhoneInvalid,
            disabled: props.isSubmitting,
            onValueChange: props.onPhoneChange,
            onKeyDown: handleSubmitOnEnter,
            errorMessage: props.phoneError
          }), /*#__PURE__*/_jsx("div", {
            className: styles['checkboxes_row'],
            children: /*#__PURE__*/_jsx(FormFieldHelper, {
              children: /*#__PURE__*/_jsxs("div", {
                className: styles['professional_row'],
                children: [/*#__PURE__*/_jsx(Checkbox, {
                  label: "\u042F \u2013 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B",
                  checked: props.isProfessionalUser,
                  onChange: props.onProfessionalUserChange
                }), /*#__PURE__*/_jsxs("span", {
                  className: styles['professional_info'],
                  children: [/*#__PURE__*/_jsx("svg", {
                    viewBox: "0 0 17 17",
                    width: "17",
                    height: "17",
                    children: /*#__PURE__*/_jsx("path", {
                      d: "M8.4 0C3.7.1-.1 3.9 0 8.6.1 13.3 3.9 17 8.6 17c4.7-.1 8.4-3.9 8.4-8.6-.1-4.7-3.9-8.5-8.6-8.4zm0 13.7c-.8 0-1.3-.6-1.3-1.3 0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.3c.1.7-.4 1.2-1.1 1.2zm3-6.1c-.2.2-.5.5-1 .9l-.5.4c-.3.2-.5.4-.6.6-.1.2-.1.2-.1.5v.1h-2v-.2c0-.7 0-1.1.3-1.4.6-.5 1.6-1.1 1.6-1.1.1-.1.3-.3.3-.4.2-.3.3-.5.3-.7 0-.3-.1-.6-.3-.8-.1-.3-.4-.4-.9-.4s-.8.2-1 .5c-.2.3-.3.6-.3 1v.1h-2v-.1c.1-1.3.5-2.2 1.3-2.7.5-.4 1.2-.6 1.9-.6 1 0 1.8.2 2.5.7.7.5 1 1.2 1 2.1 0 .6-.2 1.1-.5 1.5z"
                    })
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles['professional_info_tooltip'],
                    children: /*#__PURE__*/_jsxs("p", {
                      children: ["\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0442\u043C\u0435\u0442\u044C\u0442\u0435, \u0435\u0441\u043B\u0438 \u0432\u044B", /*#__PURE__*/_jsx("br", {}), "\u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0438\u044D\u043B\u0442\u043E\u0440,", /*#__PURE__*/_jsx("br", {}), "\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043B\u044C \u0430\u0433\u0435\u043D\u0442\u0441\u0442\u0432\u0430 \u0438\u043B\u0438 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A."]
                    })
                  })]
                })]
              })
            })
          })]
        })]
      }),
      buttons: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          "data-name": "ContinueAuthBtn",
          loading: props.isSubmitting,
          onClick: handleSubmit,
          fullWidth: true,
          children: props.submitButtonText
        }), props.activeFlow === null && /*#__PURE__*/_jsx(Button, {
          "data-name": "SwitchToPhoneAuthBtn",
          theme: "fill_secondary",
          onClick: props.onSwitchAuthByPhone,
          fullWidth: true,
          children: "\u0412\u043E\u0439\u0442\u0438 \u043F\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443"
        })]
      })
    })
  });
}